<template>
    <div class="worked_offsite pt-4">
        <employee-public-info></employee-public-info>
        <div class="row m-3 border rounded p-3">
            <div class="col-md-12">
                <b-form @submit.stop.prevent="onSubmit" style="width:300px;">


                    <div class="d-none">
                        <b-form-group id="absent-group" label-for="absent">
                            <b-form-checkbox id="absent" v-model="fdata.absent" name="absent" value="1"
                                unchecked-value="0">
                                Absent
                            </b-form-checkbox>
                        </b-form-group>
                    </div>


                    <div :class="trz_hide_me">

                        <b-form-group id="offsite-group" label-for="offsite">
                            <b-form-checkbox id="offsite" v-model="fdata.offsite" name="offsite" value="1"
                                unchecked-value="0">
                                Work offsite
                            </b-form-checkbox>
                        </b-form-group>
                        <b-form-group id="check_in-group" label="Check In" label-for="check_in"
                            v-if="fdata.absent == false">
                            <template>
                                <b-form-timepicker id="check_in" name="check_in" v-model="fdata.check_in" now-button
                                    reset-button locale="en"></b-form-timepicker>
                            </template>
                        </b-form-group>

                        <b-form-group id="checkout-group" label="Checkout" label-for="checkout"
                            v-if="fdata.absent == false">
                            <template>
                                <b-form-timepicker id="checkout" name="checkout" v-model="fdata.checkout" now-button
                                    reset-button locale="en"></b-form-timepicker>
                            </template>
                        </b-form-group>
                    </div>

                    <b-form-group id="comment-group" label="Reason/Comment" label-for="comment">
                        <b-form-textarea id="comment" name="comment" rows="3" max-rows="6" no-resize
                            v-model="fdata.comment" v-validate="{ required: true, min: 3 }"
                            :state="validateState('comment')" aria-describedby="comment-feedback"
                            data-vv-as="Reason/Comment"></b-form-textarea>
                        <b-form-invalid-feedback id="comment-feedback">{{ veeErrors.first('comment')
                            }}</b-form-invalid-feedback>
                    </b-form-group>

                    <!-- alpha fix- warp the btn in text center  -->
                    <div class="text-center">
                        <b-button type="submit" variant="primary">Submit</b-button>
                    </div>
                </b-form>
            </div>
        </div>
    </div>
</template>
<script>

export default {

    mounted() {

    },
    props: ['attendances_date', 'resolve_flg'],
    components: {

    },
    data() {


        return {

            fdata: { check_in: null, checkout: null, absent: 0, attendances_date: '' },

        }
    },
    methods: {
        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        onSubmit(e) {
            if (!this.checkNet()) return false;

            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }

                e.preventDefault();
                let currentObj = this;
                const config = {
                    //headers: { 'content-type': 'multipart/form-data' }
                }

                let formData = new FormData();

                for (let [key, value] of Object.entries(this.fdata)) {
                    var nm = `${key}`;
                    var fval = `${value}`;
                    formData.append(nm, fval);
                    //console.log(`${key}: ${value}`);
                }
                formData.append('attendances_date', this.attendances_date);

                axios.post(this.$api_url + '/attendances', formData, config)
                    .then(function (response) {
                        this.$bvToast.toast('Saved!', {
                            title: `Success`,
                            variant: 'success',
                            solid: true
                        });
                        setTimeout(function () { this.$emit('childToParent'); }.bind(this), 1000);

                    }.bind(this))
                    .catch(function (error) {

                        currentObj.serverError(error);
                    });
            });
        },


    },

    created: function () {

        //alert(this.resolve_flg);
        if (this.resolve_flg == 1) {
            this.fdata.absent = 1;
            this.trz_hide_me = 'd-none';
        }
        else {
            this.fdata.absent = 0;
            this.trz_hide_me = '';
        }

        this.fdata.offsite = 0;


    }
}
</script>
